type SortableCompetition = {
  rank: number;
  displayName: string;
};

export const compareCompetitionsByRankAndName = (a: SortableCompetition, b: SortableCompetition) =>
  a.rank - b.rank || a.displayName.localeCompare(b.displayName, 'es', { sensitivity: 'base' });
